import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { apiFormat, serverResponseFormat } from "@similarweb/pro-logic-components";

dayjs.extend(customParseFormat);

export const parseGrowthOverviewDate = (date: string): dayjs.Dayjs | null => {
    if (date.includes("|")) {
        const parsed = dayjs(date, apiFormat, true);
        return parsed.isValid() ? parsed : null;
    }

    const parsed = dayjs(date, serverResponseFormat, true);
    return parsed.isValid() ? parsed : dayjs(date).isValid() ? dayjs(date) : null;
};

export const getQuarterNumber = (date: dayjs.Dayjs): number => Math.floor(date.month() / 3) + 1;
